import { create } from "zustand";

import { vaultItemFromArtifactLink, type VaultItem } from "./morrowVault";

type VaultPreviewState = {
  item: VaultItem | null;
  open: boolean;
  openPreview: (item: VaultItem) => void;
  closePreview: () => void;
};

export const useVaultPreviewStore = create<VaultPreviewState>((set) => ({
  item: null,
  open: false,
  openPreview: (item) => set({ item, open: true }),
  closePreview: () => set({ open: false, item: null }),
}));

/** Open the shared vault preview dialog for a chat/agent vault artifact link. */
export function openVaultArtifactPreview(
  url: string,
  title?: string,
  artifactKind?: "image" | "pdf" | "video",
): boolean {
  const item = vaultItemFromArtifactLink(url, title, artifactKind);
  if (!item) return false;
  useVaultPreviewStore.getState().openPreview(item);
  return true;
}
